import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-privacy-edit',
  templateUrl: './privacy-edit.component.html',
  styleUrls: ['./privacy-edit.component.scss']
})
export class PrivacyEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
